import { render, staticRenderFns } from "./ProductNotificationEdition.vue?vue&type=template&id=5cde173a&scoped=true&"
import script from "./ProductNotificationEdition.vue?vue&type=script&lang=js&"
export * from "./ProductNotificationEdition.vue?vue&type=script&lang=js&"
import style0 from "./ProductNotificationEdition.vue?vue&type=style&index=0&id=5cde173a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde173a",
  null
  
)

export default component.exports